import React from "react";

// Props უნდა იყოს მოქცეული ფიგურულ ფრჩხილებში {}
const Logo = ({ logoClassName = "", darkMode }) => {
  return (
    <img
      // აქ ვამოწმებთ ზუსტად იმ სტრიქონს, რასაც App.js-ში ინახავ: "dark-mode"
      src={darkMode === "dark-mode" ? "/svg/logo(white).svg" : "/svg/logo.svg"}
      className={logoClassName}
      alt="Logo"
    />
  );
};

export default Logo;
